import React from 'react';
import './scroll.css'
import { Col } from 'reactstrap';
import { Link } from 'react-router-dom';


const scrollData = [
    {
        title: 'Web Applications',
        subtitle: 'Build, deploy, and scale powerful websites with ease.',
        imgUrl: require('../../assets/store-1.png'),
        url: 'https://www.es.etheware.com/'
    },
    {
        title: 'Mobile Apps',
        subtitle: 'Build, deploy, and manage compelling mobile apps and immersive mobile games.',
        imgUrl: require('../../assets/store-2.png'),
        url: 'https://www.es.etheware.com/'
    },
    
    {
        title: 'Software & SaaS',
        subtitle: 'Develop, host, and manage your custom software and SaaS products.',
        imgUrl: require('../../assets/store-3.png'),
        url: 'https://www.es.etheware.com/'
    },
    {
        title: 'eCommerce Sites',
        subtitle: 'Create secure, scalable eComm websites that drive sales.',
        imgUrl: require('../../assets/store-4.png'),
        url: 'https://www.es.etheware.com/'
    },
    {
        title: "Artificial Intelligence",
        subtitle: 'Develop, deploy, and scale your artificial intelligence applications',
        imgUrl: require('../../assets/store-5.png'),
        url: 'https://www.es.etheware.com/'
    },
    {
        title: "Blockchain & NFT's",
        subtitle: 'Create, host, and manage your blockchain apps and NFT projects.',
        imgUrl: require('../../assets/store-6.png'),
        url: 'https://www.es.etheware.com/'
    },
]

const Scroll = () => {
  return (
    <div className='scroll__container'>
        <h1 className='scroll__header'>What You Can Create with ES Manager</h1>
        <p className='scroll__subtitle'>(Scroll to View All)</p>
        <div className='scroll'>
            {scrollData.map((item, index) => (
                <Col lg='3' md='5' sm='6' key={index}>
                    <Link to={item.url}>
                    <div className="scroll__card">
                            <div className="scroll__img">
                                <img src={item.imgUrl} alt="" className='w-100 h-300px' />                         
                            </div>

                            <div className="scroll__content">
                                <div className="content__top">
                                    <h3>{item.title}</h3>
                                    <h6>{item.subtitle}</h6>
                                </div>
                            </div>
                        </div>
                    </Link>
                    </Col>
                )
            )
        }
        </div>
    </div>
        
  )
}

export default Scroll